import React from 'react';
import styled from 'styled-components';
import Text from '../../../components/Text';
import Row from '../../../components/Row';
import ActionText from '../../../components/ActionText';
import { useExternalHandlers } from '../../../services/actions/navigation/useExternalHandlers';
import { AuthPageFooter } from '../authFormCommon';

interface IAuthLegalFooterProps {
    /** When false, render only copyright + links (parent supplies layout). */
    withPageFooter?: boolean;
    className?: string;
}

const AuthLegalFooter: React.FC<IAuthLegalFooterProps> = ({ withPageFooter = true, className }) => {
    const { openTermsAndConditions, openPrivacyPolicy } = useExternalHandlers();

    const content = (
        <>
            <Text>{'LeadDelta Inc. All rights Reserved.'}</Text>
            <LinksRow gap="3px">
                <ActionText onClickHandler={() => openTermsAndConditions()}>Terms of Service</ActionText>
                <Text>and</Text>
                <ActionText onClickHandler={() => openPrivacyPolicy()}>Privacy Policy.</ActionText>
            </LinksRow>
        </>
    );

    if (!withPageFooter) {
        return <>{content}</>;
    }

    return <AuthPageFooter className={className}>{content}</AuthPageFooter>;
};

export default AuthLegalFooter;

const LinksRow = styled(Row)`
    flex-wrap: wrap;
    justify-content: center;
`;
